import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseApiService } from '../../../shared/services/api';

@Injectable({
    providedIn: 'root'
})

export class TechIntelData {

    dataObservable = new BehaviorSubject<TechIntelPayload>(null);
    constructor(private readonly baseApiService: BaseApiService) { }

    onDataReceived = this.dataObservable.asObservable();

    getExportTechIntelSavedSettingsHttp(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techIntel/export/settings');
    }

    setExportTechIntelSavedSettings(payload): Observable<any> {
        return this.baseApiService.post('service/contactcloud/techIntel/export/settings', payload);
    }

    getTechIntelSavedSettings(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techIntel/settings');
    }

    getTechIntelSavedSettingsHttp(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techIntel/settings', { showError: true });
    }

    setTechIntelSavedSettings(payload): Observable<any> {
        return this.baseApiService.post('service/contactcloud/techIntel/settings', payload);
    }
}

export interface TechIntelPayload {
    technologies: string[];
    providers: string[];
    products: string[];
}
